import React, { useState } from 'react';
import PageTitle from '../../common/PageTitle';
import { Link } from 'react-router-dom';
import SpinnerBlock from '../../common/SpinnerBlock';
import SupplyStatus from '../SupplyStatus';
import numeral from 'numeral';
import Pagination from '../../common/Pagination';
import styled from '@emotion/styled';
import ItemsSkeleton from './ItemsSkeleton';
import moment from 'moment';
import FilterBlock from './FilterBlock';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

import 'moment/locale/zh-cn';
import 'moment/locale/ru';
moment.locale('zh-cn');
moment.locale('ru');

const OrdersCardWrapper = styled('div')`
  .search-input {
    display: inline-block;
    width: 200px;
    margin-left: 10px;
    height: 38px;
    vertical-align: middle;
  }

  .table-title {
    width: 200px;
  }

  .table-supplier {
    width: 300px;
  }

  .button-filters {
    padding: 8px 13px;
  }
`;

const Wrapper = styled('div')`
  position: relative;

  .related-icon {
    display: inline-block;
    background: #e1a142;
    padding: 2px 5px;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 10px;
    margin-top: -4px;
    color: white;
    position: relative;
  }

  .related-tip {
    padding: 2px 6px;
    position: absolute;
    border: 1px solid #dee2e6;
    background: white;
    width: max-content;
    color: #7f828b;
    font-weight: normal;
    z-index: 2;
    left: -20px;
    top: 26px;
    font-size: 12px;
  }

  .thead-light th {
    font-weight: 600;
    border-bottom-color: rgb(222, 226, 230) !important;
    border-bottom-style: solid !important;
    border-bottom-width: 2px !important;
  }

  .order-id-title {
    font-weight: 700;
  }

  .fixed-table-body {
    overflow-x: auto;
  }

  tr {
    position: relative;
  }

  tr:hover {
    background-color: #f2f6f9;

    .help-tooltip {
      display: flex;
      left: 0;
      top: 60px;
    }
  }

  .help-tooltip-wrapper {
    position: absolute;
  }
`;

const DesktopLayout = (props) => {
  const {
    search,
    handleSearch,
    getSupplies,
    supplies,
    getSupplieDateString,
    suppliesCount,
    page,
    fetchSupplieList,
    currencySymbol,
    handleSetFilters,
  } = props;

  const [relatedOrdersTip, setRelatedOrdersTip] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  const customGetSupplieDateString = (date) => {
    const currentMoment = moment(date);
    let format = 'DD MMM';
    if (moment().diff(currentMoment, 'months') > 6) {
      format += ' YYYY';
    }
    format += '';
    return moment(date).locale(localeCode).format(format);
  };

  return (
    <>
      <PageTitle title={t('Поставки')} />
      <div className="row">
        <div className="col-12">
          <OrdersCardWrapper>
            <div className="card">
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-lg-4">
                    <form className="form-inline">
                      <div className="form-group mb-2">
                        <label htmlFor="ordersSearch" className="sr-only">
                          Search
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="ordersSearch"
                          placeholder={`${t('Поиск')}...`}
                          value={search}
                          onChange={handleSearch}
                        />
                        {!showFilter ? (
                          <button
                            type="button"
                            className="ml-1 btn btn-primary btn-xs waves-effect waves-light button-filters"
                            onClick={() => setShowFilter(true)}
                          >
                            <i className="fe-sliders" />
                          </button>
                        ) : null}
                      </div>
                    </form>
                  </div>
                  <div className="col-lg-8">
                    <div className="text-lg-right">
                      <Link
                        to="/supplies/new"
                        type="button"
                        className="btn btn-danger waves-effect waves-light mb-2"
                      >
                        <i className="fe-plus" /> {t('Новая поставка')}
                      </Link>
                      <Link to="/supplies/export" className="btn btn-light mb-2 mr-2 ml-4">
                        <i className="fe-arrow-down" /> {t('Экспорт')}
                      </Link>
                    </div>
                  </div>
                </div>
                {showFilter ? (
                  <FilterBlock
                    setShowFilter={setShowFilter}
                    page={page}
                    handleSetFilters={handleSetFilters}
                  />
                ) : null}
                <Wrapper>
                  {/* <SpinnerBlock show={getSupplies.isFetching} /> */}
                  <div className="fixed-table-container">
                    <div className="fixed-table-body">
                      <table className="table table-centered">
                        <thead className="thead-light">
                          <tr>
                            <th style={{ width: '300px', textAlign: 'center' }}>{t('Номер')}</th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Внутренний номер поставки')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Плановая дата прихода')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Факт. дата прихода')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Факт. дата закрытия')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Поставщик')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Грузоотправитель')}
                            </th>
                            <th style={{ width: '300px', textAlign: 'center' }}>{t('Статус')}</th>
                            <th style={{ width: '300px', textAlign: 'center' }}>{t('Склад')}</th>
                            <th style={{ width: '300px', textAlign: 'center' }}>{t('Сумма')}</th>
                            <th style={{ width: '300px', textAlign: 'center' }}>
                              {t('Количество')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {supplies?.length > 0 && supplies?.[0] !== 'NOT_FOUND' ? (
                            supplies.map((supply) => (
                              <tr key={supply.id}>
                                <td align={'center'}>
                                  {supply.warehouseFFExportError ? (
                                    <span className="help-tooltip-wrapper">
                                      <span className="help-tooltip">
                                        {supply.warehouseFFExportErrorComment}
                                      </span>
                                    </span>
                                  ) : null}
                                  <Link
                                    to={`/supplies/${supply.id}`}
                                    className="text-body order-td order-id-title"
                                  >
                                    <div
                                      className="d-flex flex-column"
                                      style={
                                        supply.warehouseFFExportError
                                          ? { color: `#f1556c` }
                                          : undefined
                                      }
                                    >
                                      <div>
                                        {supply.id}
                                        {supply.hasLinkedOrders ? (
                                          <div
                                            className="related-icon"
                                            onMouseOver={() =>
                                              setRelatedOrdersTip([...relatedOrdersTip, supply.id])
                                            }
                                            onMouseOut={() =>
                                              setRelatedOrdersTip(
                                                relatedOrdersTip.filter((id) => id !== supply.id),
                                              )
                                            }
                                          >
                                            <i className="fe-link" />
                                            {relatedOrdersTip.includes(supply.id) ? (
                                              <div className="related-tip">
                                                {t('Есть связанные заказы')}
                                              </div>
                                            ) : (
                                              false
                                            )}
                                          </div>
                                        ) : null}
                                        {` `}
                                        {supply.warehouseFFExportError ? (
                                          <i className="fe-alert-triangle" />
                                        ) : null}
                                      </div>
                                      <div>
                                        <small
                                          className={
                                            supply.warehouseFFExportError ? `` : `text-muted`
                                          }
                                        >
                                          {getSupplieDateString(supply.date)}
                                        </small>
                                      </div>
                                    </div>
                                  </Link>
                                </td>
                                <td align={'center'}>{supply.externalId}</td>
                                <td align={'center'} className="text-muted">
                                  {supply?.dateOfDeliveryPlan
                                    ? customGetSupplieDateString(supply.dateOfDeliveryPlan)
                                    : null}
                                </td>
                                <td align={'center'} className="text-muted">
                                  {supply.purchaseArrivalDate
                                    ? getSupplieDateString(supply.purchaseArrivalDate)
                                    : null}
                                </td>
                                <td align={'center'} className="text-muted">
                                  {supply.finishDate
                                    ? getSupplieDateString(supply.finishDate)
                                    : null}
                                </td>
                                <td align={'center'}>
                                  {supply.supplier ? supply.supplier.name : null}
                                </td>
                                <td align={'center'}>
                                  {supply.consignor && supply.consignor.name}
                                </td>
                                <td align={'center'}>
                                  <SupplyStatus status={supply.status} />
                                </td>
                                <td align={'center'}>{supply.warehouseName}</td>
                                <td align={'center'}>{`${numeral(supply.totalOrderSum).format(
                                  '0,0.00',
                                )} ${currencySymbol}`}</td>
                                <td align={'center'}>
                                  {supply.totalQuantity} {t('шт')}
                                </td>
                              </tr>
                            ))
                          ) : supplies?.[0] === 'NOT_FOUND' ? (
                            <p className="mt-1 fs-4">{t('Поставки не найдены')}</p>
                          ) : (
                            <>
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                              <ItemsSkeleton />
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Wrapper>
                <Pagination
                  total={suppliesCount}
                  currentPage={page}
                  onPageSelect={fetchSupplieList}
                />
              </div>
            </div>
          </OrdersCardWrapper>
        </div>
      </div>
    </>
  );
};

export default DesktopLayout;
